import React from 'react'
import { ActivityIndicator, View } from 'react-native'
import { Paragraph, Dialog, Portal, Provider } from 'react-native-paper'

type CatalogUpdateProps = {
  isVisible: boolean,
}

/**
 * The loading indicator used during the version checks and catalog updates.
 * @component
 */
export class CatalogUpdate extends React.Component<CatalogUpdateProps> {
  constructor(props: CatalogUpdateProps) {
    super(props)
  }
  render() {
    return (
      <Provider>
        <View style={{ position: 'absolute', width: '1%', height: '10%', justifyContent: 'center', flexDirection: 'row', marginLeft: 10, marginRight: 10 }} >
          <Portal>
            <Dialog visible={this.props.isVisible} style={{ position: 'absolute', width: '60%', justifyContent: 'center', flexDirection: 'column', padding: '5%', alignSelf: 'center' }} >
              <Dialog.Title style={{ textAlign: 'center' }}>Updating Catalog</Dialog.Title>
              <Dialog.Content>
                <ActivityIndicator />
              </Dialog.Content>
              <Dialog.Content>
                <Paragraph style={{ textAlign: 'center' }}>Please ensure that you have third party cookies enabled in your browser.</Paragraph>
              </Dialog.Content>
            </Dialog>
          </Portal>
        </View>
      </Provider>
    )
  }
}